// extracted by mini-css-extract-plugin
module.exports = {"SetFilterIcon":"SetFilterIcon_SetFilterIcon__1BL5U"};